import { Ignore } from '@master/annotation/Ignore'
import { IDateService } from '@master/services/IDateService'
import { ArrayBase } from '../ArrayBase'
import { MaxChar } from '@master/annotation/MaxChar'
import { InputMaxChar } from '@master/enum/MaxCharsEnum'
import { ClientBase } from '@master/model/ClientBase';

export default class ExistingInsurenceDetails extends ClientBase {
  isLoaded = false;
  discloseExistingInsurance: boolean | null = null;
  hasNoExistingInsurance: boolean | null = null;
  optOutNeedsAnalysis: boolean | null = null;
  justification = ''

  justificationError: boolean | null = false;

  skipOptions: 'no_insurance' | 'no_disclose' | 'disclose_existing_insurance' | '' = '';

  DDdepentants = [];
  insuranceRecords = [];
  dependants = [];
  hospitalPlanCover: boolean


  existingInsurenceHospitalPlanCover: boolean | null = null;

  cantRememberDate: boolean | null = null;

  @MaxChar(InputMaxChar.XXXLARGE)
  existingInsuranceDeclrationNote = ''

  ExistingInsureAdditionalNote   = ''

  constructor (type: 'client_0' | 'client_1' = 'client_0') {
    super(type);
    this.DDdepentants = [];
    this.insuranceRecords = [];
    this.dependants = [];
  }

  toFieldUpdateJson() {
    return {
      discloseExistingInsurance: this.discloseExistingInsurance,
      hasNoExistingInsurance: this.hasNoExistingInsurance,
      optOutNeedsAnalysis: this.optOutNeedsAnalysis,
      justification : this.justification,
      ExistingInsureAdditionalNote : this.ExistingInsureAdditionalNote,
      existingInsuranceDeclrationNote : this.existingInsuranceDeclrationNote
    }
  }

  setData(newData) {
    for (const key in newData) {
      if (this.hasOwnProperty(key)) {
        this[key] = newData[key];
      }
    }
      // Set skipOptions based on BE boolean flags
    this.skipOptions = '';
    const noInsurance = newData?.hasNoExistingInsurance === true;
    const noDisclose = newData?.optOutNeedsAnalysis === true;
    const disclose = newData?.discloseExistingInsurance === true;

    if (noInsurance && !noDisclose && !disclose) {
      this.skipOptions = 'no_insurance';
    } else if (noDisclose && !noInsurance && !disclose) {
      this.skipOptions = 'no_disclose';
    } else if (disclose && !noDisclose && !noInsurance) {
      this.skipOptions = 'disclose_existing_insurance';
    }
    this.isLoaded = true;
  }
}

export class ExistingInsurence extends ArrayBase {
  type = 'ExistingInsurence'

  @Ignore()
  dateService: IDateService

  constructor(dateService: IDateService) {
    super()
  }

  hospitalPlanCover: boolean = false
  owner: string = ''
  commencementDate?: string | number
  cannotRemember: boolean = false
  lifeCompany: string = ''
  policyType: string = ''
  premium: number
  sumAssuredDeath: number
  sumAssuredTPD: number
  sumAssuredCI: number
  sumAssuredPA: number
  sumAssuredMaternity: number
  monthlyBenefitLTC: number
  cashValue: number
  remarks: string = ''
  lifeCompanyAndPolicyType: string = ''
}
